import React, { useEffect } from "react";
import { FaLinkedinIn, FaPinterestP, FaInstagram, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const ProjectDetailsModal = ({ darkTheme, projectDetails }) => {
  // Debug: Verificar qué proyecto se está mostrando
  // Debug info removed for production
  
  // Función para generar enlaces de compartir
  const getShareUrl = (platform) => {
    const projectUrl = projectDetails?.url?.link || 'https://fachu.dev';
    const projectTitle = projectDetails?.title || 'Portfolio Project';
    const description = projectDetails?.projectInfo || 'Check out this amazing project';
    
    switch (platform) {
      case 'linkedin':
        return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(projectUrl)}`;
      case 'twitter':
        return `https://twitter.com/intent/tweet?url=${encodeURIComponent(projectUrl)}&text=${encodeURIComponent(`Check out ${projectTitle}: ${description}`)}`;
      case 'whatsapp':
        return `https://wa.me/?text=${encodeURIComponent(`${projectTitle}: ${description} ${projectUrl}`)}`;
      case 'pinterest':
        return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(projectUrl)}&description=${encodeURIComponent(`${projectTitle} - ${description}`)}`;
      case 'instagram':
        // Instagram no permite compartir directo via URL, pero podemos copiar al clipboard
        return '#';
      case 'email':
        return `mailto:?subject=${encodeURIComponent(`Check out: ${projectTitle}`)}&body=${encodeURIComponent(`Hi! I wanted to share this amazing project with you:\n\n${projectTitle}\n${description}\n\nTake a look: ${projectUrl}`)}`;
      default:
        return '#';
    }
  };

  // Función para manejar el click en Instagram
  const handleInstagramShare = () => {
    const text = `${projectDetails?.title}: ${projectDetails?.projectInfo} ${projectDetails?.url?.link || 'https://fachu.dev'}`;
    navigator.clipboard.writeText(text).then(() => {
      alert('Link copied to clipboard! You can now paste it in Instagram.');
    });
  };

  useEffect(() => {
    const modal = document.getElementById('exampleModal');
    
    const handleModalHidden = () => {
      // Pausar todos los videos cuando se cierre el modal
      const videos = document.querySelectorAll('video');
      videos.forEach(video => {
        video.pause();
        video.currentTime = 0; // Resetear al inicio
        video.load(); // Forzar recarga del video
      });
    };

    const handleModalShow = () => {
      // Cuando se abre el modal, pausar videos anteriores
      const videos = document.querySelectorAll('video');
      videos.forEach(video => {
        video.pause();
        video.currentTime = 0;
      });
    };

    if (modal) {
      modal.addEventListener('hidden.bs.modal', handleModalHidden);
      modal.addEventListener('show.bs.modal', handleModalShow);
      
      // Cleanup
      return () => {
        modal.removeEventListener('hidden.bs.modal', handleModalHidden);
        modal.removeEventListener('show.bs.modal', handleModalShow);
      };
    }
  }, []);

  // Effect adicional para limpiar videos cuando cambie el proyecto
  useEffect(() => {
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
      video.pause();
      video.currentTime = 0;
      video.load();
    });
  }, [projectDetails?.title]);
  
  return (
    <>
      <div
        className="modal fade bg-dark-1"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div
            className={
              "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
            }
          >
            <div className="modal-body">
              <button
                type="button"
                className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <div
                className={
                  "container ajax-container " +
                  (darkTheme ? "bg-dark-2 text-light" : "")
                }
              >
                <h2
                  className={
                    "text-6 font-weight-600 text-center mb-4" +
                    (darkTheme ? " text-white" : "")
                  }
                >
                  {projectDetails?.title}
                </h2>
                <div className="row g-4">
                  <div className="col-md-7">
                    {/* Video específico para Policing Lab */}
                    {(projectDetails?.title === "Policing Lab" || projectDetails?.id === "policing-lab") ? (
                      <div className="project-video-container">
                        {/* Video para Policing Lab */}
                        <video
                          key={`policing-lab-video`}
                          className="img-fluid w-100"
                          autoPlay
                          loop
                          muted
                          playsInline
                          style={{
                            borderRadius: '10px',
                            objectFit: 'cover',
                            border: '10px solid black'
                          }}
                          onError={(e) => console.error('Error cargando video:', e)}
                          onLoadStart={() => {}}
                          onCanPlay={() => {}}
                        >
                          <source src="/videos/policing-video.mp4" type="video/mp4" />
                          Tu navegador no soporta el elemento de video.
                        </video>
                      </div>
                    ) : (
                      /* Verificar si hay videos en sliderImages o mostrar imágenes */
                      <div className="project-media-container">
                        {projectDetails?.sliderImages?.length > 0 && (() => {
                          // Buscar videos (.mp4) en sliderImages
                          const videoSrc = projectDetails.sliderImages.find(src => src.endsWith('.mp4'));
                          
                          if (videoSrc) {
                            return (
                              <div className="project-video-container">
                                <video
                                  key={`${projectDetails?.title}-video`}
                                  className="img-fluid w-100"
                                  autoPlay
                                  loop
                                  muted
                                  playsInline
                                  style={{
                                    borderRadius: '10px',
                                    objectFit: 'cover',
                                    border: '10px solid black'
                                  }}
                                >
                                  <source src={videoSrc} type="video/mp4" />
                                  Tu navegador no soporta el elemento de video.
                                </video>
                              </div>
                            );
                          } else {
                            // Mostrar imagen si no hay video
                            return (
                              <div className="project-image">
                                <img 
                                  className="img-fluid" 
                                  alt={projectDetails?.title}
                                  src={projectDetails.sliderImages[0]} 
                                  style={{
                                    borderRadius: '8px',
                                    width: '100%'
                                  }}
                                />
                              </div>
                            );
                          }
                        })()}
                      </div>
                    )}
                  </div>
                  <div className="col-md-5">
                    <h4
                      className={
                        "text-4 font-weight-600" +
                        (darkTheme ? " text-white" : "")
                      }
                    >
                      Description:
                    </h4>
                    <p>{projectDetails?.projectInfo}</p>
                    <h4
                      className={
                        "text-4 font-weight-600 mt-4" +
                        (darkTheme ? " text-white" : "")
                      }
                    >
                      Details:
                    </h4>
                    <ul
                      className={
                        "list-style-2 " + (darkTheme ? "list-style-light" : "")
                      }
                    >
                      <li>
                        <span
                          className={
                            "text-dark font-weight-600 me-2" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          Work for:
                        </span>
                        {projectDetails?.clientLink ? (
                          <a
                            href={projectDetails.clientLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={darkTheme ? "text-light" : ""}
                            style={{ textDecoration: 'none' }}
                          >
                            {projectDetails?.client}
                          </a>
                        ) : (
                          projectDetails?.client
                        )}
                        {projectDetails?.clientFlag && (
                          <span className="ms-2">{projectDetails.clientFlag}</span>
                        )}
                      </li>
                      <li>
                        <span
                          className={
                            "text-dark font-weight-600 me-2" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          Technologies:
                        </span>
                        {projectDetails?.technologies}
                      </li>
                      <li>
                        <span
                          className={
                            "text-dark font-weight-600 me-2" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          Industry:
                        </span>
                        {projectDetails?.industry}
                      </li>
                      <li>
                        <span
                          className={
                            "text-dark font-weight-600 me-2" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          Date:
                        </span>
                        {projectDetails?.date}
                      </li>
                      <li>
                        <span
                          className={
                            "text-dark font-weight-600 me-2" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          URL:
                        </span>
                        <a
                          href={projectDetails?.url?.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {projectDetails?.url?.name}
                        </a>
                      </li>
                    </ul>
                    <div className="row no-gutters align-items-center">
                      <div
                        className={
                          "col-auto text-dark font-weight-600" +
                          (darkTheme ? " text-white" : "")
                        }
                      >
                        Share:
                      </div>
                      <div className="col-auto">
                        <ul
                          className={
                            "social-icons" +
                            (darkTheme ? " social-icons-muted" : "")
                          }
                        >
                          <li className="social-icons-linkedin">
                            <a
                              data-toggle="tooltip"
                              href={getShareUrl('linkedin')}
                              target="_blank"
                              rel="noopener noreferrer"
                              data-original-title="Share on LinkedIn"
                            >
                              <FaLinkedinIn />
                            </a>
                          </li>
                          <li className="social-icons-twitter">
                            <a
                              data-toggle="tooltip"
                              href={getShareUrl('twitter')}
                              target="_blank"
                              rel="noopener noreferrer"
                              data-original-title="Share on X"
                            >
                              <FaXTwitter />
                            </a>
                          </li>
                          <li className="social-icons-whatsapp">
                            <a
                              data-toggle="tooltip"
                              href={getShareUrl('whatsapp')}
                              target="_blank"
                              rel="noopener noreferrer"
                              data-original-title="Share on WhatsApp"
                            >
                              <FaWhatsapp />
                            </a>
                          </li>
                          <li className="social-icons-instagram">
                            <button
                              data-toggle="tooltip"
                              onClick={handleInstagramShare}
                              data-original-title="Copy link for Instagram"
                              style={{
                                background: 'none',
                                border: 'none',
                                padding: '0',
                                color: 'inherit',
                                cursor: 'pointer'
                              }}
                            >
                              <FaInstagram />
                            </button>
                          </li>
                          <li className="social-icons-pinterest">
                            <a
                              data-toggle="tooltip"
                              href={getShareUrl('pinterest')}
                              target="_blank"
                              rel="noopener noreferrer"
                              data-original-title="Share on Pinterest"
                            >
                              <FaPinterestP />
                            </a>
                          </li>
                          <li className="social-icons-email">
                            <a
                              data-toggle="tooltip"
                              href={getShareUrl('email')}
                              data-original-title="Share via Email"
                            >
                              <FaEnvelope />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectDetailsModal;
